const listStatesHR = [
  { id: '1', name: 'Liq. de mercaderia' },
  { id: '2', name: 'Liq. de mercaderia +' },
  { id: '3', name: 'Liq. de documento' },
  { id: '4', name: 'Liq. de documento +' },
  { id: 'L', name: 'Liq. HR' },
  { id: '5', name: 'Cerrado' }
];

export { listStatesHR };
